import Swal from 'sweetalert2'

const newAlert = (type, title = '', message = '') => {
  if (type && (title || message)) {
    Swal.fire(title, message, { closeOnClickOutside: false })
  }
}

const confirmAlert = (
  title,
  message,
  type,
  showCancelButton = true,
  html = '',
  colorCancelButton = '#6e7881'
) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: type,
      dangerMode: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: colorCancelButton,
      showCancelButton: showCancelButton,
      allowOutsideClick: false,
      closeOnClickOutside: false
    }).then(function (isConfirm) {
      resolve(isConfirm.isConfirmed)
    })
  })
}

export default { newAlert, confirmAlert }
